import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgLock = props => _jsx("svg", _objectSpread(_objectSpread({
  width: 34,
  height: 44,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: _jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0c5.891 0 10.7 4.63 10.986 10.451L28 11v5.5h2.75a2.75 2.75 0 0 1 2.75 2.75v22A2.75 2.75 0 0 1 30.75 44H3.25A2.75 2.75 0 0 1 .5 41.25v-22a2.75 2.75 0 0 1 2.75-2.75H6V11C6 4.925 10.925 0 17 0Zm13.75 19.25H3.25v22h27.5v-22ZM17 27.5a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5Zm0-24.75a8.25 8.25 0 0 0-8.236 7.765L8.75 11v5.5h16.5V11A8.25 8.25 0 0 0 17 2.75Z",
    fill: props.color || "#58595B"
  })
}));
export default SvgLock;